import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch, FiHelpCircle } = FiIcons;

const SearchBox = ({ onSearch, placeholder = "Buscar fuentes académicas y de IA...", showHelp = true }) => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      if (onSearch) {
        onSearch(query.trim());
      } else {
        navigate(`/search?q=${encodeURIComponent(query.trim())}`);
      }
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative">
          {/* Search Icon */}
          <div className="absolute left-5 top-1/2 transform -translate-y-1/2 z-10">
            <SafeIcon icon={FiSearch} className="w-6 h-6 text-gray-400" />
          </div>

          {/* Input Field */}
          <textarea
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
            placeholder={placeholder}
            rows={1}
            className="w-full px-6 py-4 pl-14 pr-32 text-lg bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-2xl shadow-lg focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:focus:ring-indigo-900 outline-none transition-all duration-200 text-gray-900 dark:text-white resize-none overflow-hidden min-h-[60px]"
            style={{
              maxHeight: '120px',
              lineHeight: '1.5'
            }}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
            }}
          />

          {/* Search Button - FIXED POSITION */}
          <button
            type="submit"
            className="absolute right-3 top-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-6 py-2 rounded-xl font-medium transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!query.trim()}
          >
            Buscar
          </button>
        </div>
      </form>

      {showHelp && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-4 text-center"
        >
          <button
            onClick={() => navigate('/help')}
            className="inline-flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
          >
            <SafeIcon icon={FiHelpCircle} className="w-4 h-4" />
            <span>¿Necesitas ayuda con la búsqueda? Ver guía de operadores</span>
          </button>
        </motion.div>
      )}
    </div>
  );
};

export default SearchBox;